export default __webpack_public_path__ + "static/media/card2.cd88b228.svg";